import { useState } from "react";
import { DEVICE_TYPES } from "../../../common/constant/common-constants";
import { ALARM_PRIORITY } from "../../../common/constant/common-constants";
import { handleOutsideClick } from "../../../common/utils/CommonUtils";
import moment from 'moment';
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
// import low-priority from "../../../common/icons/alarm/low-priority-alarm.png";
import './DeviceTabDesktopView.scss'
import { PATIENT_TYPE } from "../../../common/ENUMS/PARAMETER_ENUM";
import { TEMP_MODE } from "../../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { connect } from "react-redux";

function DeviceTabDesktopView({
    activeVitalDevice,
    deviceAlarmData,
    showMoreAlarms_1,
    showMoreAlarms_2,
    handleShowMoreAlarmsClick_1,
    handleShowMoreAlarmsClick_2,
    handleSeeAllAlarms,
    getAlarmPriorityClass
}) {

    return (
        <div className='machine-tabs-wrap'>

            {activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5'] ? (
                <div className="patient-monitor-alarm">

                    {/* Physiological alarms */}
                    <div className="mode-container-1">
                        {deviceAlarmData?.alarms_physiological?.length ?
                            <div
                                className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData.alarms_physiological[0])}`}
                                onClick={handleShowMoreAlarmsClick_1}
                                id="alarm-display-bar-1"
                            >
                                <div className="top-alarm-container">
                                    {deviceAlarmData.alarms_physiological[0]?.message}

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {deviceAlarmData.alarms_physiological?.length}
                                        <img
                                            style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                            src={
                                                showMoreAlarms_1
                                                    ? (deviceAlarmData.alarms_physiological[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                        ? whiteUpArrow : blackUpArrow)
                                                    : (deviceAlarmData.alarms_physiological[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                        ? whiteDownArrow : blackDownArrow)
                                            }
                                            className="arrow-icon"
                                            alt="accordion arrow"
                                        />
                                    </div>
                                </div>

                                {showMoreAlarms_1 &&
                                    <div className="more-alarm-container">
                                        {deviceAlarmData.alarms_physiological.map((alarm, count) => {
                                            if (count > 3) return null;
                                            return (
                                                <div className="alarm more-alarm" key={count}>
                                                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        <img
                                                            src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`}
                                                            style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                                            alt="alarm icon"
                                                        />
                                                        {alarm.message}
                                                    </div>
                                                    <span className="alarm-time">
                                                        {alarm.time && moment(alarm.time).format("HH:mm:ss")}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                        <div className="see-all-container" onClick={handleSeeAllAlarms}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div style={{ width: '58%', marginRight: '12px' }} />
                        }
                    </div>

                    {/* Technical alarms */}
                    <div className="mode-container-2">
                        {deviceAlarmData?.alarms__technical?.length ?
                            <div
                                className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData.alarms__technical[0])}`}
                                onClick={handleShowMoreAlarmsClick_2}
                                id="alarm-display-bar-2"
                            >
                                <div className="top-alarm-container">
                                    {deviceAlarmData.alarms__technical[0]?.message}

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {deviceAlarmData.alarms__technical?.length}
                                        <img
                                            style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                            src={
                                                showMoreAlarms_2
                                                    ? (deviceAlarmData.alarms__technical[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                        ? whiteUpArrow : blackUpArrow)
                                                    : (deviceAlarmData.alarms__technical[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                        ? whiteDownArrow : blackDownArrow)
                                            }
                                            className="arrow-icon"
                                            alt="accordion arrow"
                                        />
                                    </div>
                                </div>

                                {showMoreAlarms_2 &&
                                    <div className="more-alarm-container">
                                        {deviceAlarmData.alarms__technical.map((alarm, count) => {
                                            if (count > 3) return null;
                                            return (
                                                <div className="alarm more-alarm" key={count}>
                                                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        <img
                                                            src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`}
                                                            style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                                            alt="alarm icon"
                                                        />
                                                        {alarm.message}
                                                    </div>
                                                    <span className="alarm-time">
                                                        {alarm.time && moment(alarm.time).format("HH:mm:ss")}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                        <div className="see-all-container" onClick={handleSeeAllAlarms}>
                                            See all
                                        </div>
                                    </div>
                                }
                            </div>
                            :
                            <div style={{ width: '58%', marginRight: '12px' }} />
                        }
                    </div>

                </div>
            ) : (
                <div className="mode-container-3">

                    {deviceAlarmData?.length ?
                        <div
                            className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData[0])}`}
                            onClick={handleShowMoreAlarmsClick_1}
                            id="alarm-display-bar-1"
                        >
                            <div className="top-alarm-container">
                                {deviceAlarmData[0]?.name}

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {deviceAlarmData?.length}
                                    <img
                                        style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                        src={
                                            showMoreAlarms_1
                                                ? (deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                    ? whiteUpArrow : blackUpArrow)
                                                : (deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH"
                                                    ? whiteDownArrow : blackDownArrow)
                                        }
                                        className="arrow-icon"
                                        alt="accordion arrow"
                                    />
                                </div>
                            </div>

                            {showMoreAlarms_1 &&
                                <div className="more-alarm-container">
                                    {deviceAlarmData.map((alarm, count) => {
                                        if (count > 3) return null;
                                        return (
                                            <div className="alarm more-alarm" key={count}>
                                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                    <img
                                                        src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`}
                                                        style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                                        alt="alarm icon"
                                                    />
                                                    {alarm.name}
                                                </div>
                                                <span className="alarm-time">
                                                    {alarm.time && moment(alarm.time, "YYYYMMDDHHmmss").format("HH:mm:ss")}
                                                </span>
                                            </div>
                                        );
                                    })}

                                    <div className="see-all-container" onClick={handleSeeAllAlarms}>
                                        See all
                                    </div>
                                </div>
                            }
                        </div>
                        :
                        <div style={{ width: '58%', marginRight: '12px' }} />
                    }
                </div>
            )}
        </div>
    );
}

export default DeviceTabDesktopView;
